import {ConfigObjectType, StateId} from '@wallaby-ui/core';
import {debounce} from 'lodash';
import * as React from 'react';
import {useMemo} from 'react';
import {connect, ConnectedProps} from 'react-redux';

import {MuiSelectedFilters} from './MuiSelectedFilters';
import {getServiceUrls} from 'src/js/containers/filter_and_search/filter_and_search_selectors';
import {
  changeParamsAndQuery,
  changeQueryParams,
} from 'src/js/containers/filter_and_search/filter_and_search_thunks';
import {removeAllFiltersAndQuery} from 'src/js/containers/filtering/filtering_actions';
import {
  getDefaultValueFilters,
  getNotEmptySelectedFilters,
} from 'src/js/containers/filtering/filtering_selectors';
import {gridSlice} from 'src/js/containers/grid';
import {
  getGridSort,
  getGridStateId,
} from 'src/js/containers/grid/grid_selectors';
import {RootState} from 'src/js/store';
import {useAppDispatch} from 'src/js/store_hooks';

interface OwnProps {
  config: ConfigObjectType;
  gridId: string;
  filterAndSearchStateId: StateId;
  filteringStateId: StateId;
  serviceUrls: Record<string, any>;
  count?: number;
  areButtonsOutlined?: boolean;
  featureName?: string;
}

const mapState = (state: RootState, props: OwnProps) => ({
  serviceUrlsBySelector: getServiceUrls(state, props),
  selectedFilters: getNotEmptySelectedFilters(state, props),
  defaultValueFilters: getDefaultValueFilters(state, props),
  currentSort: getGridSort(state, props),
  gridStateId: getGridStateId(state, props),
});

const mapDispatch = {
  removeAllFiltersAndQueryAC: removeAllFiltersAndQuery,
  changeParamsAndQueryAC: changeParamsAndQuery,
  changeQueryParamsAC: changeQueryParams,
  changeGridParamsAC: gridSlice.actions.changeGridParams,
};

const connector = connect(mapState, mapDispatch);
type PropsFromRedux = ConnectedProps<typeof connector>;

type Props = PropsFromRedux & OwnProps;

export const MuiSelectedFiltersContainerComponent: React.FC<Props> = (
  props
) => {
  const {
    removeAllFiltersAndQueryAC,
    serviceUrlsBySelector,
    changeParamsAndQueryAC,
    changeQueryParamsAC,
    filteringStateId,
    filterAndSearchStateId,
    selectedFilters,
    count,
    currentSort,
    changeGridParamsAC,
    gridStateId,
    defaultValueFilters,
    areButtonsOutlined = true,
    featureName,
  } = props;

  const dispatch = useAppDispatch();

  const debouncedChangeParamsAndQuery = useMemo(
    () => debounce(changeParamsAndQueryAC, 500).bind(this),
    [changeParamsAndQueryAC]
  );

  const handleRemoveAllFilters = () => {
    removeAllFiltersAndQueryAC(
      serviceUrlsBySelector.searchService,
      debouncedChangeParamsAndQuery,
      filteringStateId,
      filterAndSearchStateId,
      featureName
    );
  };

  const handleResetSorting = () => {
    if (currentSort) {
      changeQueryParamsAC(filterAndSearchStateId, {sort: []}, featureName);
      dispatch(changeGridParamsAC(gridStateId, {params: {sort: []}}));
    }
  };

  return (
    <MuiSelectedFilters
      handleRemoveAllFilters={handleRemoveAllFilters}
      handleResetSorting={handleResetSorting}
      selectedFilters={selectedFilters}
      defaultValueFilters={defaultValueFilters}
      currentSort={currentSort}
      count={count}
      areButtonsOutlined={areButtonsOutlined}
    />
  );
};

MuiSelectedFiltersContainerComponent.displayName =
  'MuiSelectedFiltersContainer';

export const MuiSelectedFiltersContainer = connector(
  MuiSelectedFiltersContainerComponent
);
